import React from 'react'
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M8.6,20.6c-0.3,0.3-0.7,0.5-1,0.5c-0.3,0-0.8-0.2-1-0.5L0,14l2.1-2.1l5.4,5.4L22,2.9L24,5L8.6,20.6z" />
  </React.Fragment>,
  'CheckmarkIcon'
)
